import type { FC, PropsWithChildren } from 'react';

import { S } from './styles';

interface CarouselTitleProps {
  id: string;
}

export const CarouselTitle: FC<CarouselTitleProps & PropsWithChildren> = ({
  id,
  children,
  ...props
}) => (
  <S.Title id={`${id}-title`} variant="h1" component="h2" {...props} data-cs-capture="">
    {children}
  </S.Title>
);
